import { render, staticRenderFns } from "./SendModal.vue?vue&type=template&id=77d2a564&"
import script from "./SendModal.vue?vue&type=script&lang=js&"
export * from "./SendModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports